import { render, staticRenderFns } from "./ArtMinigame.vue?vue&type=template&id=fac60840&scoped=true"
import script from "./ArtMinigame.vue?vue&type=script&lang=js"
export * from "./ArtMinigame.vue?vue&type=script&lang=js"
import style0 from "./ArtMinigame.vue?vue&type=style&index=0&id=fac60840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac60840",
  null
  
)

export default component.exports